// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-list__item {
  padding: 15px !important;
}
@media (min-width: 768px) {
  .download-list__item {
    padding: 25px !important;
  }
}
.download-list__item-meta > div {
  margin-inline-end: 8px !important;
}
@media (min-width: 768px) {
  .download-list__item-meta > div {
    margin-inline-end: 10px !important;
  }
}
.download-list__save-file-container {
  margin-top: 10px;
  margin-bottom: 5px;
  text-align: right;
  color: white !important;
}
.download-list__save-file-button {
  padding: 5px 10px;
  border-radius: 6px;
  color: white !important;
  background-color: #0085bb !important;
  border-color: #0085bb !important;
}
.download-list__save-file-button:hover {
  color: white !important;
  background-color: #249ece !important;
  border-color: #249ece !important;
}
.download-list__icon svg {
  width: 30px;
  height: 30px;
}
@media (min-width: 768px) {
  .download-list__icon svg {
    width: 35px;
    height: 35px;
  }
}
.download-list .ant-list-item-action {
  margin-left: 5px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/functional/DownloadsList/DownloadList.scss"],"names":[],"mappings":"AAGI;EACI,wBAAA;AAFR;AAIQ;EAHJ;IAIQ,wBAAA;EADV;AACF;AAII;EACI,iCAAA;AAFR;AAIQ;EAHJ;IAIQ,kCAAA;EADV;AACF;AAII;EACI,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;AAFR;AAKI;EACI,iBAAA;EACA,kBAAA;EAEA,uBAAA;EACA,oCAAA;EACA,gCAAA;AAJR;AAMQ;EACI,uBAAA;EACA,oCAAA;EACA,gCAAA;AAJZ;AAQI;EACI,WAAA;EACA,YAAA;AANR;AAQQ;EAJJ;IAKQ,WAAA;IACA,YAAA;EALV;AACF;AAQI;EACI,2BAAA;AANR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
